import { useEffect } from "react";
import { useLocation } from "wouter";
import { trackHubSpotPageView } from "@/lib/hubspot";

/** Public marketing surfaces where SPA page views should be recorded. */
const MARKETING_PATHS = [
  "/",
  "/welcome",
  "/demo",
  "/terms",
  "/privacy",
  "/subprocessors",
  "/security",
];

function isMarketingPath(location: string): boolean {
  if (MARKETING_PATHS.includes(location)) return true;
  return location.startsWith("/sign-in") || location.startsWith("/sign-up");
}

/**
 * HubSpot's embed is in index.html (required for their install checker).
 * This component records additional SPA navigations on marketing routes.
 */
export function HubSpotTracker() {
  const [location] = useLocation();

  useEffect(() => {
    if (!isMarketingPath(location)) return;
    trackHubSpotPageView(location);
  }, [location]);

  return null;
}
